import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { RootState } from '../types';
import { getFacilities, getListingIsCharitable } from '../selectors';
import { getFacilitiesByGroup } from '../utils/getFacilitiesByGroup';
import { ListingFacilitiesSection } from '../components/ListingFacilitiesSection';

const getFacilitiesGroups = createSelector(getFacilities, getFacilitiesByGroup);

const ListingFacilitiesSectionContainer = connect((state: RootState) => ({
  facilities: getFacilitiesGroups(state),
  isCharitable: getListingIsCharitable(state),
}))(ListingFacilitiesSection);
export { ListingFacilitiesSectionContainer };
